'use client'

import { Builder } from '@builder.io/react'

import { ImageCard } from './ImageCard'
import { imageCardDefaults } from './ImageCard.defaults'

Builder.registerComponent(ImageCard, {
  name: 'ImageCard',
  inputs: [
    {
      name: 'heading',
      type: 'html',
      defaultValue: imageCardDefaults.heading,
    },
    {
      name: 'subheading',
      type: 'html',
      defaultValue: imageCardDefaults.subheading,
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
      defaultValue: imageCardDefaults.imageSrc,
    },
    {
      name: 'headingColor',
      type: 'color',
      defaultValue: imageCardDefaults.headingColor,
    },
    {
      name: 'subheadingColor',
      type: 'color',
      defaultValue: imageCardDefaults.subheadingColor,
    },
    {
      name: 'redirectUrl',
      type: 'string',
      defaultValue: imageCardDefaults.redirectUrl,
    },
    {
      name: 'showGradient',
      type: 'boolean',
      defaultValue: imageCardDefaults.showGradient,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/photo.svg',
})
